import { PagedSearch } from '../../../shared/model/paged-search.model';

export class AttendeeSearchParams extends PagedSearch {
  public constructor() {
    super();

    this.Keyword = '';
    this.PageSize = 10;
    this.OrderBy = 'SignUpDate:desc';
    this.EventId = 0;
    this.SignUpStartDate = new Date();
    this.SignUpEndDate = new Date();
    this.AllUnpaid = false;
    this.AllWithBlankAttendees = false;
    this.AllWithProfileIdNotAssigned = false;
    this.EventItemIds = new Array<number>();
    this.RegistrationId = 0;
    this.AttendeeIds = new Array<number>();
    this.ExcludedAttendeeIds = new Array<number>();
  }

  public Keyword: string;
  public EventId: number;
  public SearchAnySignUpDate: boolean = true;
  public SignUpStartDate: Date;
  public SignUpEndDate: Date;
  public AllUnpaid: boolean;
  public AllWithBlankAttendees: boolean;
  public AllWithProfileIdNotAssigned: boolean;
  public EventItemIds: Array<number>;

  public RegistrationId: number;
  public AttendeeIds: Array<number>;
  public ExcludedAttendeeIds: Array<number>;
  public AllAttended: boolean;
}
